const API_URL = '/api/quotecart';

class QuoteCartService {
    async getCart() {
        try {
            const response = await fetch(API_URL, {
                headers: this.getHeaders()
            });
            if (!response.ok) throw new Error('Failed to fetch cart');
            return await response.json();
        } catch (err) {
            console.error('QuoteCartService.getCart error:', err);
            throw err;
        }
    }

    async addItem(item) {
        try {
            const response = await fetch(API_URL + '/items', {
                method: 'POST',
                headers: this.getHeaders(),
                body: JSON.stringify(item)
            });
            if (!response.ok) {
                const errorText = await response.text();
                let errorMsg = 'Failed to add item to cart';
                try {
                    const errorJson = JSON.parse(errorText);
                    errorMsg = errorJson.message || errorMsg;
                } catch (e) { /* ignore parse error */ }
                throw new Error(errorMsg);
            }
            return await response.json();
        } catch (err) {
            console.error('QuoteCartService.addItem error:', err);
            throw err;
        }
    }

    async updateItem(itemId, updates) {
        try {
            const response = await fetch(API_URL + '/items/' + itemId, {
                method: 'PUT',
                headers: this.getHeaders(),
                body: JSON.stringify(updates)
            });
            if (!response.ok) {
                const errorText = await response.text();
                let errorMsg = 'Failed to update item';
                try {
                    const errorJson = JSON.parse(errorText);
                    errorMsg = errorJson.message || errorMsg;
                } catch (e) { /* ignore parse error */ }
                throw new Error(errorMsg);
            }
            return await response.json();
        } catch (err) {
            console.error('QuoteCartService.updateItem error:', err);
            throw err;
        }
    }

    async removeItem(itemId) {
        try {
            const response = await fetch(API_URL + '/items/' + itemId, {
                method: 'DELETE',
                headers: this.getHeaders()
            });
            if (!response.ok) throw new Error('Failed to remove item');
            return await response.json();
        } catch (err) {
            console.error('QuoteCartService.removeItem error:', err);
            throw err;
        }
    }

    async clearCart() {
        try {
            const response = await fetch(API_URL, {
                method: 'DELETE',
                headers: this.getHeaders()
            });
            if (!response.ok) throw new Error('Failed to clear cart');
            return await response.json();
        } catch (err) {
            console.error('QuoteCartService.clearCart error:', err);
            throw err;
        }
    }

    async submitCart(customerInfo) {
        try {
            const response = await fetch(API_URL + '/submit', {
                method: 'POST',
                headers: this.getHeaders(),
                body: JSON.stringify(customerInfo)
            });
            if (!response.ok) {
                const errorText = await response.text();
                let errorMsg = 'Failed to submit quote request';
                try {
                    const errorJson = JSON.parse(errorText);
                    errorMsg = errorJson.message || errorMsg;
                } catch (e) { /* ignore parse error */ }
                throw new Error(errorMsg);
            }
            return await response.json();
        } catch (err) {
            console.error('QuoteCartService.submitCart error:', err);
            throw err;
        }
    }

    async getCartCount() {
        try {
            const response = await fetch(API_URL + '/count', {
                headers: this.getHeaders()
            });
            if (!response.ok) return { count: 0 };
            return await response.json();
        } catch (err) {
            // Silently fail for cart count - not critical
            console.warn('QuoteCartService.getCartCount error:', err);
            return { count: 0 };
        }
    }

    getHeaders() {
        const token = localStorage.getItem('token');
        return {
            'Content-Type': 'application/json',
            ...(token && { 'Authorization': 'Bearer ' + token })
        };
    }
}

export default new QuoteCartService();
